// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const stub = (...args: unknown[]) => {};
